import styled from "styled-components";
import renderComponent from "../../utils/serializers/renderComponent";

const WidgetsWrapper = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr;
`;

export const MultipleWidgetsWrapper=(props)=>{
    return(
        <WidgetsWrapper>
          {props?.block?.elements.map(x => {return renderComponent(x)})}
        </WidgetsWrapper>
    )
}